import { render, staticRenderFns } from "./UnSubscribe.vue?vue&type=template&id=39584e3a&scoped=true&"
import script from "./UnSubscribe.vue?vue&type=script&lang=js&"
export * from "./UnSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./UnSubscribe.vue?vue&type=style&index=0&id=39584e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39584e3a",
  null
  
)

export default component.exports